import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
} from "@angular/router";

import { AuthService } from "../services/auth.service";

@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredRoles = route.data['roles'] ?? [];

        const hasRole = requiredRoles.some((role: string) => 
            this.authService.hasRole(role)
        );

        if (!hasRole) {
            this.router.navigate(['/unauthorized']);
            return false
        }

        return true;
    }
}